import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  id: string;
};

type ErrorResponse = {
  errors?: string[];
};

const EXPORT_ERROR_MESSAGE = 'Export failed';

const getExportErrorMessage = async (error: unknown) => {
  const axiosError = error as AxiosError<ErrorResponse | Blob>;
  const responseData = axiosError.response?.data;

  try {
    if (responseData instanceof Blob) {
      const text = await responseData.text();
      const data = JSON.parse(text) as ErrorResponse;
      return data.errors?.[0] ?? EXPORT_ERROR_MESSAGE;
    }

    return responseData?.errors?.[0] ?? EXPORT_ERROR_MESSAGE;
  } catch {
    return EXPORT_ERROR_MESSAGE;
  }
};

export const useExportPayout = createMutation<Blob, Variables, Error>({
  mutationFn: async ({ id }) => {
    try {
      const response = await client.get(`v2/payouts/${id}/export`, {
        responseType: 'blob',
      });

      return response.data as Blob;
    } catch (error) {
      throw new Error(await getExportErrorMessage(error));
    }
  },
});
